import React from 'react';
import { motion } from 'framer-motion';
import { HeartHandshake, HandCoins, Landmark } from 'lucide-react';

import supportFoundation from '../assest/support.png';

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const fadeLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1 }
  }
};

const fadeRight = {
  hidden: { opacity: 0, x: 80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1 }
  }
};

const Foundation = () => {
  return (
    <motion.section
      className="py-8 bg-blue-50"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeUp}
    >
      <div className="max-w-7xl mx-auto px-4">

        <motion.div
          className="bg-white rounded-[3rem] p-8 md:p-16 shadow-xl border border-blue-100 flex flex-col lg:flex-row gap-12 items-center"
          variants={fadeUp}
        >

          {/* LEFT SIDE */}
          <motion.div
            className="flex-1"
            variants={fadeLeft}
          >
            <h2 className="text-4xl font-black text-slate-900 mb-6">
              Support Our Foundation
            </h2>

            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Sridhar Dental Hospital Foundation is committed to making advanced dental care accessible to all. We provide subsidized treatments for low-income families and fund complex surgeries for children in need.
            </p>

            <div className="grid sm:grid-cols-1 gap-6 mb-10">

              <motion.div
                className="flex gap-4"
                whileHover={{ x: 6 }}
              >
                <div className="shrink-0 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-primary">
                  <HeartHandshake />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">Child Care Fund</h4>
                  <p className="text-sm text-slate-500">
                    Corrective surgeries for children.
                  </p>
                </div>
              </motion.div>

              <motion.div
                className="flex gap-4"
                whileHover={{ x: 6 }}
              >
                <div className="shrink-0 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-primary">
                  <HandCoins />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">Patient Subsidy</h4>
                  <p className="text-sm text-slate-500">
                    Helping elders with dentures.
                  </p>
                </div>
              </motion.div>

            </div>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="w-full sm:w-auto bg-primary text-white px-10 py-4 rounded-2xl font-bold shadow-lg hover:bg-secondary transition-all flex items-center justify-center gap-3"
            >
              <Landmark size={20} />
              Donate to Foundation
            </motion.button>
          </motion.div>

          {/* RIGHT SIDE */}
          <motion.div
            className="flex-1 grid grid-cols-2 gap-4"
            variants={fadeRight}
          >

            <div className="space-y-4">

              <motion.img
                whileHover={{ scale: 1.03 }}
                src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&q=80&w=500"
                className="rounded-3xl h-48 w-full object-cover"
                alt="Care"
              />

              <motion.div
                whileHover={{ y: -5 }}
                className="bg-primary p-8 rounded-3xl text-white"
              >
                <p className="text-3xl font-black">25+</p>
                <p className="text-sm opacity-80 uppercase font-bold">
                  Years of Trust
                </p>
              </motion.div>

            </div>

            <div className="pt-8 space-y-4">

              <motion.div
                whileHover={{ y: -5 }}
                className="bg-blue-500 p-8 rounded-3xl text-white"
              >
                <p className="text-3xl font-black">1500+</p>
                <p className="text-sm opacity-80 uppercase font-bold">
                  Free Surgeries
                </p>
              </motion.div>

              <motion.img
                whileHover={{ scale: 1.03 }}
                src={supportFoundation}
                className="rounded-3xl h-48 w-full object-cover"
                alt="Foundation"
              />

            </div>

          </motion.div>

        </motion.div>
      </div>
    </motion.section>
  );
};

export default Foundation;